<template>
	<div class="introduce">
		<Header></Header>
		<div class="introduce_main_box">
			<h5>课题咨询</h5>
			<p>
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;国研网依托其传统的信息资源优势和专业的研究咨询团队，结合多年积累的庞大数据库资源和在政策研究、宏观经济、行业分析、战略规划和数据库建设等领域积累的丰富经验，在提供基础信息资源、集成信息资源（信息平台）、决策分析平台的基础上，针对用户在某领域或某项决策上对于研究结果的直接需求，提供专项课题研究及决策咨询服务。国研网课题研究和决策咨询服务包括政策课题研究、经济课题研究、指数编制研究，具体分类、说明及案例如下，欢迎垂询！<br />

				<strong style="margin-top:25px;display:block;"
					>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：400-7070-678
					E-mail：salse@drcnet.com.cn</strong
				>

				<strong style="margin-top:25px;display:block;"
					>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;课题咨询服务类别说明及案例</strong
				>

				<el-table
					:data="tableData"
					border
					:cell-style="{
						'font-weight': 'bold',
						'font-size': '16px',
						'text-align': 'center',
						padding: '30px 10px',
					}"
					:header-cell-style="{
						'font-weight': 'bold',
						'font-size': '16px',
						'text-align': 'center',
					}"
					style="width:100%;margin:20px auto;"
				>
					<el-table-column prop="title" label="类别" width="180">
					</el-table-column>
					<el-table-column prop="name" label="服务内容" width="520">
					</el-table-column>
					<el-table-column prop="address" label="服务案例">
					</el-table-column>
				</el-table>
			</p>
		</div>
		<infor></infor>
		<div style="margin-bottom: 20px 0;"></div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';
import infor from '../infor/index.vue';
export default {
	props: {},
	components: {
		Header,
		Footer,
		infor,
	},
	data() {
		return {
			tableData: [
				{
					title: '政策课题研究',
					name:
						'基于各类型经济社会政策的研究课题，包括用户关注领域的政策发展脉络和发展导向跟踪研究、发展战略与规划研究、重大政策解读及政策实施效果研究、以及为政府提供的政策决策咨询服务。',
					address:
						'《深圳“互联网+”发展模式和策略研究》《东莞市人工智能政策研究》',
				},
				{
					title: '经济课题研究',
					name:
						'包括宏观经济、金融、产业经济、区域经济、对外经济等经济各领域的发展态势和运行模式研究，帮助用户前瞻、准确的了解经济发展脉络和动因，找到经济发展对自身的影响，并提出应对建议。',
					address: '《双碳背景下绿色债券市场发展趋势》',
				},
				{
					title: '指数编制研究',
					name:
						'包括经济、产业、金融等热点领域发展态势研究，并通过编制指数衡量发展阶段，为热点领域研究提供定量支持，并提出应对建议。',
					address:
						'《数字经济发展指数报告》《绿色金融区域发展指数报告》',
				},
			],
		};
	},
	computed: {},
	methods: {},
	created() {},
	mounted() {},
};
</script>
<style scoped lang="less">
.introduce {
	width: 100%;
	// height: 100%;
	background: #f2f2f2;
}
.introduce_main_box {
	width: 1200px;
	margin: 0 auto;
	min-height: 600px;
}
.introduce_main_box p {
	font-size: 16px;
	line-height: 2.5;
	margin-bottom: 70px;
	color: #202223;
	font-family: '微软雅黑', 'Heiti SC', '黑体', 'Arial';
}
.introduce_main_box h5 {
	width: 100%;
	text-align: center;
	font-size: 30px;
	font-weight: bold;
	margin: 60px 0 30px;
}
.introduce_main_box strong {
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/topic/index.vue